"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _theme = require("@zip/theme");

var _polished = require("polished");

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

var _hexRgb = _interopRequireDefault(require("./hex-rgb"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @deprecated create component variations instead - https://material-ui.com/customization/components/
 */
var muiTheme = function muiTheme(theme) {
  var _paperScrollPaper, _root2, _root3;

  return (0, _core.createTheme)({
    breakpoints: _breakpoints["default"],
    overrides: {
      MuiAccordion: {
        root: {
          margin: 0,
          '&$expanded': {
            margin: 0
          },
          '&::before': {
            content: 'unset'
          }
        }
      },
      MuiAccordionDetails: {
        root: {
          padding: 0
        }
      },
      MuiAccordionSummary: {
        content: {
          margin: '32px 0 24px',
          '&$expanded': {
            margin: '32px 0 24px'
          }
        },
        expandIcon: {
          alignSelf: 'flex-start',
          margin: '18px -12px 0 0'
        },
        root: {
          padding: 0,
          '&$expanded': {
            minHeight: 'inherit'
          }
        }
      },
      MuiAppBar: {
        colorSecondary: {
          backgroundColor: theme.colors.white
        },
        root: {
          // We want it to overlay the drawer (which is z-index 1200)
          zIndex: 1300
        }
      },
      MuiBackdrop: {
        root: {
          backgroundColor: "".concat((0, _hexRgb["default"])(theme.colors.white, 0.02))
        }
      },
      MuiButton: {
        root: {
          borderRadius: theme.radii.lg,
          fontFamily: theme.fonts.body1.family,
          fontSize: theme.fontSizes.body1,
          fontWeight: theme.fontWeights.medium,
          height: 50,
          lineHeight: theme.lineHeights.body1,
          letterSpacing: theme.letterSpacings.body1,
          minWidth: 148,
          overflow: 'hidden',
          textTransform: 'none',
          whiteSpace: 'nowrap'
        },
        containedPrimary: {
          backgroundColor: theme.colors.primary.dark,
          '&:active': {
            backgroundColor: theme.colors.primary.dark,
            boxShadow: "0 0 0 4px ".concat(theme.colors.neutral[200], " !important")
          },
          '&:disabled': {
            backgroundColor: theme.name === _theme.fearlessBusiness.name ? (0, _polished.rgba)(theme.colors.neutral[600], 0.5) : theme.colors.primary.dark,
            color: theme.name === _theme.fearlessBusiness.name ? theme.colors.white : (0, _polished.rgba)(theme.colors.white, 0.5),
            opacity: 0.4
          },
          '&:hover': {
            '@media (hover: none)': {
              backgroundColor: theme.colors.primary.dark
            }
          }
        },
        containedSecondary: {
          backgroundColor: theme.colors.primary.lightest,
          color: theme.name === _theme.fearlessBusiness.name ? theme.colors.primary.medium : theme.colors.primary.dark,
          fontSize: theme.fontSizes.body1,
          '&:active': {
            backgroundColor: theme.colors.primary.lightest,
            boxShadow: "0 0 0 4px ".concat(theme.colors.neutral[200], " !important")
          },
          '&:disabled': {
            backgroundColor: theme.colors.primary.lightest,
            color: theme.name === _theme.fearlessBusiness.name ? theme.colors.primary.medium : theme.colors.primary.dark,
            opacity: 0.4
          },
          '&:hover': {
            '@media (hover: none)': {
              backgroundColor: theme.colors.primary.lightest
            }
          }
        },
        outlined: {
          border: theme.colors.neutral[300]
        },
        outlinedPrimary: {
          borderColor: theme.name === _theme.fearlessBusiness.name ? theme.colors.primary.medium : theme.colors.primary.dark,
          color: theme.name === _theme.fearless.name ? theme.colors.primary.dark : theme.colors.primary.medium,
          '&:active': {
            backgroundColor: 'transparent',
            boxShadow: "0 0 0 4px ".concat(theme.colors.neutral[200], " !important")
          },
          '&:hover': {
            backgroundColor: theme.colors.neutral[50],
            borderColor: theme.name === _theme.fearlessBusiness.name ? theme.colors.primary.medium : theme.colors.primary.dark
          }
        },
        textPrimary: {
          color: theme.colors.accent,
          fontSize: theme.fontSizes.body1,
          lineHeight: theme.lineHeights.body1,
          letterSpacing: theme.letterSpacings.body1,
          '&:active': {
            boxShadow: "0 0 0 4px ".concat(theme.colors.neutral[50], " !important")
          },
          '&:disabled': {
            color: theme.colors.neutral[400]
          }
        }
      },
      MuiCard: {
        root: {
          border: "solid 1px ".concat(theme.colors.neutral[100]),
          boxShadow: 'none'
        }
      },
      MuiCardActions: {
        root: {
          padding: '0 24px 24px'
        }
      },
      MuiCardContent: {
        root: {
          padding: '24px'
        }
      },
      MuiCheckbox: {
        root: {
          marginLeft: '-9px',
          marginRight: '7px',
          '&$colorPrimary': {
            '&:hover': {
              backgroundColor: (0, _polished.rgba)(theme.colors.primary.medium, 0.1)
            },
            '&$checked:hover': {
              backgroundColor: (0, _polished.rgba)(theme.colors.primary.medium, 0.1)
            }
          }
        }
      },
      MuiDialog: {
        paper: {
          margin: 16
        },
        paperFullScreen: _defineProperty({}, "@media (max-width: ".concat(_breakpoints["default"].values.sm, "px)"), {
          padding: '24px 16px 0',
          top: 'env(safe-area-inset-top, 0)',
          bottom: 'env(safe-area-inset-bottom, 0)'
        }),
        paperFullWidth: _defineProperty({
          borderRadius: '10px'
        }, "@media (max-width: ".concat(_breakpoints["default"].values.sm, "px)"), {
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          borderRadius: '10px 10px 0 0',
          margin: 0,
          width: 'unset'
        }),
        paperScrollPaper: (_paperScrollPaper = {
          maxHeight: 'calc(100% - 175px)'
        }, _defineProperty(_paperScrollPaper, "@media (max-width: ".concat(_breakpoints["default"].values.sm, "px)"), {
          maxHeight: '100%'
        }), _defineProperty(_paperScrollPaper, "@media (max-height: 864px)", {
          maxHeight: '100%'
        }), _defineProperty(_paperScrollPaper, "zIndex", 200), _paperScrollPaper),
        paperWidthFalse: {
          maxWidth: 'unset'
        },
        paperWidthSm: _defineProperty({
          width: 520
        }, "@media (max-width: ".concat(_breakpoints["default"].values.xs, ")"), {
          maxWidth: '100%'
        }),
        root: {
          backdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(0,0,0,0.4)',
          mixBlendMode: 'normal',
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore - it does accept a string, damn it
          zIndex: '1400 !important'
        }
      },
      MuiPopover: {
        root: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore - it does accept a string, damn it
          // needed to show Select dropdowns on dialogs
          zIndex: '1500 !important'
        }
      },
      MuiDialogActions: {
        root: {
          position: 'sticky',
          bottom: 0,
          padding: '12px 20px',
          background: theme.colors.white,
          zIndex: 100
        },
        spacing: {
          '& > :not(:first-child)': {
            marginLeft: 12
          }
        }
      },
      MuiDialogContent: {
        root: _defineProperty({
          padding: '20px 32px',
          overflow: 'visible'
        }, "@media (max-width: ".concat(_breakpoints["default"].values.sm, "px)"), {
          padding: '24px 16px'
        })
      },
      MuiDrawer: {
        paper: {
          boxShadow: "0 4px 40px ".concat((0, _hexRgb["default"])(theme.colors.black, 0.08)),
          padding: '64px 0 0'
        },
        root: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          zIndex: '1200 !important'
        }
      },
      MuiFormControlLabel: {
        root: {
          marginLeft: 0,
          marginRight: 0
        },
        label: {
          color: theme.colors.title,
          fontFamily: theme.fonts.body2.family,
          fontSize: theme.fontSizes.body2,
          lineHeight: theme.lineHeights.body2,
          letterSpacing: theme.letterSpacings.body2,
          '&$disabled': {
            color: theme.colors.neutral[200]
          }
        }
      },
      MuiFormHelperText: {
        root: {
          marginTop: '4px',
          color: theme.colors.neutral[500],
          fontFamily: theme.fonts.body4.family,
          fontSize: theme.fontSizes.body4,
          lineHeight: theme.lineHeights.body4,
          letterSpacing: theme.letterSpacings.body4
        },
        contained: {
          marginLeft: '16px',
          marginRight: '16px'
        }
      },
      MuiIconButton: {
        root: {
          margin: '0 -6px',
          padding: '5px'
        },
        colorPrimary: {
          '&:hover': {
            backgroundColor: (0, _hexRgb["default"])(theme.colors.neutral[300], 0.2)
          }
        }
      },
      MuiInputBase: {
        root: {
          color: theme.colors.secondary,
          fontFamily: theme.fonts.body2.family,
          fontSize: theme.fontSizes.heading4,
          lineHeight: theme.lineHeights.heading4,
          letterSpacing: theme.letterSpacings.heading4
        }
      },
      MuiInputLabel: {
        root: {
          color: theme.colors.neutral[500],
          fontFamily: theme.fonts.body2.family,
          fontSize: theme.fontSizes.heading4,
          // hardcoding for vertically centered text
          lineHeight: '1em',
          letterSpacing: theme.letterSpacings.heading4,
          '&$focused': {
            color: theme.colors.primary.medium
          }
        }
      },
      MuiLinearProgress: {
        bar: {
          borderRadius: '10px'
        },
        bar2Buffer: {
          backgroundColor: (0, _polished.rgba)('#F8991C', 0.2)
        },
        dashed: {
          animation: 'initial'
        },
        barColorPrimary: {
          backgroundColor: '#F8991C'
        },
        barColorSecondary: {
          backgroundColor: '#00AEB8'
        },
        colorPrimary: {
          backgroundColor: 'transparent'
        },
        dashedColorPrimary: {
          backgroundImage: 'initial',
          backgroundPosition: 'initial',
          backgroundSize: 'initial'
        },
        root: {
          borderRadius: '10px',
          height: '8px'
        }
      },
      MuiListItem: {
        button: {
          '&:hover': {
            backgroundColor: (0, _polished.rgba)(theme.colors.accent, 0.1)
          }
        },
        root: {
          width: 'auto',
          '&$selected': {
            backgroundColor: (0, _polished.rgba)(theme.colors.neutral[300], 0.2)
          },
          '&$selected:hover': {
            backgroundColor: (0, _polished.rgba)(theme.colors.accent, 0.1)
          },
          fontFamily: theme.fonts.body2.family,
          justifyContent: 'space-between'
        },
        divider: {
          borderBottomColor: theme.colors.neutral[100]
        }
      },
      MuiListItemIcon: {
        alignItemsFlexStart: {
          marginTop: 0
        },
        root: {
          margin: '0 12px 0 0',
          minWidth: 'auto'
        }
      },
      MuiListItemText: {
        inset: {
          paddingLeft: '44px'
        },
        multiline: {
          marginTop: 0
        },
        root: {
          marginBottom: 0,
          marginTop: 0
        }
      },
      MuiMenu: {
        paper: {
          borderRadius: theme.radii.md
        },
        list: {
          maxHeight: 250
        }
      },
      MuiListSubheader: {
        root: (_root2 = {
          minHeight: '40px'
        }, _defineProperty(_root2, "@media (min-width: ".concat(_breakpoints["default"].values.sm, "px)"), {
          minHeight: '40px'
        }), _defineProperty(_root2, "fontFamily", theme.fonts.body2.family), _defineProperty(_root2, "fontSize", theme.fontSizes.heading4), _defineProperty(_root2, "lineHeight", theme.lineHeights.heading4), _defineProperty(_root2, "letterSpacing", theme.letterSpacings.heading4), _defineProperty(_root2, "color", theme.colors.neutral[600]), _defineProperty(_root2, "backgroundColor", theme.colors.background), _defineProperty(_root2, "userSelect", 'none'), _defineProperty(_root2, "padding", '16px 16px 8px'), _defineProperty(_root2, "display", 'flex'), _defineProperty(_root2, "alignItems", 'center'), _defineProperty(_root2, '&:has(~ li.MuiListItem-root)&:not(:first-of-type)', {
          borderTop: "1px solid ".concat(theme.colors.neutral[100])
        }), _root2),
        sticky: {
          backgroundColor: theme.colors.background
        }
      },
      MuiMenuItem: {
        root: (_root3 = {
          minHeight: '40px'
        }, _defineProperty(_root3, "@media (min-width: ".concat(_breakpoints["default"].values.sm, "px)"), {
          minHeight: '40px'
        }), _defineProperty(_root3, "fontFamily", theme.fonts.body2.family), _defineProperty(_root3, "fontSize", theme.fontSizes.heading4), _defineProperty(_root3, "lineHeight", theme.lineHeights.heading4), _defineProperty(_root3, "letterSpacing", theme.letterSpacings.heading4), _defineProperty(_root3, "paddingTop", 8), _defineProperty(_root3, "paddingBottom", 8), _defineProperty(_root3, '&:has(+ li.MuiListSubheader-root)', {
          margin: '0px 0px 8px' // 8px (padding) + 8px (margin) = 16px

        }), _root3)
      },
      MuiPickersCalendarHeader: {
        switchHeader: {
          padding: '0 20px'
        }
      },
      MuiOutlinedInput: {
        adornedEnd: {
          paddingRight: '14px'
        },
        input: {
          padding: '18.5px 16px'
        },
        root: {
          '&:hover $notchedOutline': {
            borderColor: theme.colors.neutral[600]
          },
          '& $notchedOutline': {
            borderColor: theme.colors.neutral[500]
          },
          '&:hover $focused $notchedOutline': {
            borderColor: theme.colors.primary.medium
          },
          '&$focused $notchedOutline': {
            borderColor: theme.colors.primary.medium
          }
        }
      },
      MuiPaper: {
        elevation24: _defineProperty({
          boxShadow: "0px -6px 36px ".concat((0, _polished.rgba)(theme.colors.black, 0.06))
        }, "@media (min-width: ".concat(_breakpoints["default"].values.sm, "px)"), {
          boxShadow: "0 0 36px ".concat((0, _polished.rgba)(theme.colors.black, 0.08))
        }),
        outlined: {
          border: "solid 1px ".concat((0, _polished.rgba)(theme.colors.neutral[300], 0.8)),
          borderRadius: '8px',
          padding: '16px'
        },
        root: {
          color: theme.colors.neutral[600]
        },
        rounded: {
          borderRadius: theme.radii.lg
        }
      },
      MuiRadio: {
        root: {
          marginRight: '7px',
          '&$colorPrimary': {
            '&:hover': {
              backgroundColor: (0, _polished.rgba)(theme.colors.primary.medium, 0.1)
            },
            '&$checked:hover': {
              backgroundColor: (0, _polished.rgba)(theme.colors.primary.medium, 0.1)
            }
          }
        }
      },
      MuiSelect: {
        icon: {
          color: theme.colors.neutral[400]
        },
        iconOutlined: {
          right: '13px'
        },
        select: {
          '&:focus': {
            backgroundColor: 'none'
          }
        },
        selectMenu: {
          // hardcoding for consistent heights across inputs
          height: '1.1876em',
          // hardcoding for vertically centered text
          lineHeight: '1em'
        }
      },
      MuiSlider: {
        root: {
          height: 18
        },
        mark: {
          top: '50%',
          transform: 'translateY(-50%)',
          borderRadius: '50%',
          height: '8px',
          width: '8px',
          backgroundColor: 'transparent'
        },
        markActive: {
          backgroundColor: (0, _polished.rgba)(theme.colors.white, 0.6)
        },
        rail: {
          borderRadius: '20px',
          height: '18px',
          margin: '0 -15px',
          width: 'calc(100% + 30px)',
          backgroundColor: (0, _polished.rgba)(theme.colors.neutral[300], 0.5),
          '[data-color="primary"] &': {
            background: 'linear-gradient(90deg, #262E6E -11.34%, #4F5BB8 35.22%)',
            opacity: 'initial'
          },
          '[data-color="secondary"] &': {
            backgroundColor: theme.colors.primary.lightest
          },
          '[data-is-minimum="true"] &': {
            backgroundColor: (0, _polished.rgba)('#F9E3B9', 0.5)
          }
        },
        thumb: {
          boxShadow: '0px 1px 20px rgba(0, 0, 0, 0.15)',
          height: '40px',
          marginLeft: 0,
          marginTop: '-10px',
          width: '40px',
          backgroundColor: theme.colors.white,
          transform: 'translateX(-50%)',
          transition: 'box-shadow 80ms linear',
          '@media (hover: none)': {
            '&.Mui-focusVisible, &:hover': {
              // Didn't want to use `!important` here but MUI's API is sticky as hell
              boxShadow: '0px 1px 20px rgba(0, 0, 0, 0.15) !important'
            }
          }
        },
        track: {
          borderRadius: '20px 0 0 20px',
          height: '18px',
          margin: '0 -15px',
          background: 'linear-gradient(90deg, #262E6E -11.34%, #4F5BB8 35.22%);',
          backgroundSize: '250px',
          '[data-color="primary"] &': {
            background: 'linear-gradient(90deg, #262E6E -11.34%, #4F5BB8 35.22%)',
            backgroundColor: '#4F5BB8'
          },
          '[data-color="secondary"] &': {
            background: "linear-gradient(90deg, ".concat(theme.colors.primary.main, " 0%, ").concat(theme.colors.primary.light, " 100%)"),
            backgroundColor: theme.colors.primary.light
          },
          '[data-is-minimum="true"] &': {
            background: "linear-gradient(90deg, #FAD082 0%, #F9E3B9 100%)",
            backgroundColor: '#F9E3B9'
          }
        },
        valueLabel: {
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) !important',
          '& *': {
            background: 'transparent',
            color: '#000'
          }
        }
      },
      MuiSwitch: {
        switchBase: {
          color: theme.colors.white,
          margin: 0
        },
        colorPrimary: {
          '&$checked': {
            color: theme.colors.accent,
            '& + $track': {
              backgroundColor: theme.colors.primary.lightest,
              opacity: 1
            }
          }
        },
        track: {
          backgroundColor: (0, _polished.rgba)(theme.colors.neutral[300], 0.5),
          opacity: 1
        }
      },
      MuiTableCell: {
        head: {
          color: theme.colors.secondary,
          fontFamily: theme.fonts.body1.family,
          fontSize: theme.fontSizes.body1,
          fontWeight: theme.fontWeights.medium,
          letterSpacing: theme.letterSpacings.body1,
          lineHeight: theme.lineHeights.body1
        }
      },
      MuiTypography: {
        body1: {
          fontSize: 'inherit'
        }
      },
      MuiDivider: {
        light: {
          backgroundColor: theme.colors.neutral[100]
        },
        root: {
          backgroundColor: theme.colors.neutral[200]
        }
      },
      MuiLink: {
        button: {
          fontFamily: theme.fonts.body1.family,
          fontSize: theme.fontSizes.body1,
          fontWeight: theme.fontWeights.medium,
          lineHeight: theme.lineHeights.body1,
          letterSpacing: theme.letterSpacings.body1,
          '&:disabled': {
            opacity: '30%',
            cursor: 'default',
            '&:hover': {
              textDecoration: 'none'
            }
          }
        }
      },
      MuiChip: {
        root: {
          fontFamily: theme.fonts.body4.family,
          fontSize: theme.fontSizes.body4,
          lineHeight: theme.lineHeights.body4,
          letterSpacing: theme.letterSpacings.body4,
          borderRadius: theme.radii.md,
          padding: '2px 8px',
          width: 'fit-content',
          height: 'fit-content',
          '&:not(:first-of-type)': {
            margin: '0 0 0 8px'
          }
        },
        label: {
          paddingLeft: 0,
          paddingRight: 0
        }
      },
      MuiTooltip: {
        tooltip: {
          fontFamily: theme.fonts.body4.family,
          fontSize: theme.fontSizes.body4,
          lineHeight: theme.lineHeights.body4,
          letterSpacing: theme.letterSpacings.body4,
          fontWeight: 400,
          borderRadius: theme.radii.md
        }
      },
      MuiTouchRipple: {
        child: {
          backgroundColor: (0, _polished.rgba)(theme.colors.primary.medium, 0.25)
        }
      },
      MuiPickersDay: {
        day: {
          color: theme.colors.body
        },
        current: {
          color: theme.colors.body
        },
        daySelected: {
          backgroundColor: theme.colors.accent,
          '&:hover': {
            backgroundColor: theme.colors.accent
          }
        }
      },
      MuiPickersModal: {
        dialogRoot: {
          margin: 0,
          padding: '24px 16px',
          maxWidth: '345px',
          '& > .MuiDialogActions-root': {
            paddingTop: 0,
            paddingBottom: 0,
            justifyContent: 'space-between',
            '& > .MuiButton-root': {
              borderRadius: theme.radii.md,
              height: 'auto',
              minWidth: 'unset'
            }
          },
          overflow: 'hidden'
        }
      }
    },
    palette: {
      primary: {
        // light: '',
        main: theme.colors.primary.medium,
        dark: function () {
          switch (theme.name) {
            case _theme.fearlessBusiness.name:
              return theme.colors.neutral[500];

            default:
              return theme.colors.secondary;
          }
        }(),
        contrastText: theme.colors.white
      },
      secondary: {
        // light: '',
        main: theme.colors.neutral[400],
        dark: theme.colors.primary.lighter,
        contrastText: theme.colors.primary.main
      },
      error: {
        //   light: '',
        main: theme.colors.danger //   dark: '',
        //   contrastText: '',

      },
      text: {
        primary: theme.colors.primary.main // secondary: '',
        // disabled: '',
        // hint: '',

      }
    },
    typography: {
      fontFamily: 'inherit',
      body1: {
        fontWeight: 'inherit'
      }
    }
  });
};

var _default = muiTheme;
exports["default"] = _default;